import boopSfx from '../mp3/card.mp3';
import leaveSfx from '../mp3/leave.mp3';
import whatsappSfx from '../mp3/whatsapp.mp3';

class SoundManager {
  constructor() {
    this.lastPlayedMessageId = null;
    this.activeSounds = {};
  }

  async playSound(soundType, messageUid = null) {
    try {
      if (soundType === 'new') {
        if (messageUid && messageUid !== this.lastPlayedMessageId) {
          const audio = new Audio(boopSfx);
          await audio.play();
          this.lastPlayedMessageId = messageUid;
        }
      } else if (soundType === 'leave') {
        const audio = new Audio(leaveSfx);
        await audio.play();
      } else if (soundType === 'internal_message') {
        const audio = new Audio(whatsappSfx);
        await audio.play();
      }
    } catch (error) {
      console.error(`Erro ao reproduzir som '${soundType}':`, error);
    }
  }

  async startRinging(type = 'incoming') {
    try {
      this.stopRinging();

      // Use premium royalty-free SFX for a better user experience
      const soundUrl =
        type === 'outgoing'
          ? '/mixkit-waiting-ringtone-1354.wav' // Custom dial tone requested by user
          : '/bling_bang_bang_born.mp3'; // Pleasant ringtone

      const audio = new Audio(soundUrl);
      audio.loop = true;
      await audio.play();
      this.activeSounds.ringtone = audio;
    } catch (error) {
      console.error('Erro ao iniciar toque de chamada:', error);
    }
  }

  stopRinging() {
    if (this.activeSounds.ringtone) {
      this.activeSounds.ringtone.pause();
      this.activeSounds.ringtone.currentTime = 0;
      delete this.activeSounds.ringtone;
    }
  }
}

export const soundManager = new SoundManager();
